export default __webpack_public_path__ + "static/media/6C8A7704.d0af6db0.jpg";